import { isBrowserOnline } from './network'
import { opPermissions } from './resolutionPolicy'

/**
 * Helper murni untuk menerjemahkan error upload antrean async jadi teks & keputusan
 * retry (dipisah dari uploader supaya mudah di-unit-test).
 */

/** Pesan error ringkas dari axios untuk disimpan ke op (max 300 char). */
export const errText = (err) => {
  if (err == null) {
    return 'Tidak dapat terhubung ke server'
  }
  // Interceptor axios me-reject dengan `error.response` ({status, data}); gagal
  // jaringan me-reject AxiosError tanpa response → baca keduanya.
  const res = err?.response ?? err
  const status = res?.status
  const data = res?.data
  if (!status && (err?.code === 'ERR_NETWORK' || !isBrowserOnline())) {
    return 'Tidak dapat terhubung ke server'
  }
  const fieldErrors =
    data?.errors && typeof data.errors === 'object' ? Object.values(data.errors).flat() : []
  const msg = data?.message || fieldErrors[0] || data?.error || err?.message || 'Upload gagal'
  const prefix = status ? `[${status}] ` : ''
  return `${prefix}${String(msg)}`.slice(0, 300)
}

/** Status HTTP dari error axios/interceptor. */
export const errStatus = (err) => (err?.response ?? err)?.status

/**
 * Penolakan permanen BE untuk seluruh batch: 400 (kombinasi type×action / ref_id
 * tak valid), 403 (izin POS kurang), 422 (validasi). Percuma di-retry.
 */
export const isPermanentReject = (err) => {
  const status = errStatus(err)
  return status === 400 || status === 403 || status === 422
}

/** Pesan mentah server (tanpa prefix status) — untuk deteksi pesan khusus /resolve. */
export const serverMessage = (err) =>
  String((err?.response ?? err)?.data?.message ?? err?.message ?? '')

/** Pesan error op; 403 ditambah nama izin yang dibutuhkan supaya admin tahu. */
export const opErrText = (err, op) => {
  const base = errText(err)
  const perms = errStatus(err) === 403 ? opPermissions(op) : []
  return perms.length ? `${base} — akun kasir butuh izin ${perms.join(', ')}`.slice(0, 300) : base
}
